import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Button } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import moment from "moment";

import Swal from "sweetalert2";

import channelUserApi from "../../../apis/ChannelUser.api";
import { toastAlert } from "../../../components/AlertComponent";
import SignupAgreement from "../../../components/channel/signup/SignupAgreement";
import SignupGenderAge from "../../../components/channel/signup/SignupGenderAge";
import SignRouteSurvey from "../../../components/channel/signup/SignupRouteSurvey";
import SignupUserInfo from "../../../components/channel/signup/SignupUserInfo";
import { setChannelUser } from "../../../redux/store/auth/authDuck";
import { setLoading } from "../../../redux/store/common/commonDuck";
// import {setChannelUser} from "../../../redux/store/auth/authDuck";

const SignUp = () => {
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	// const user = useSelector(state => state.auth.user);

	const dispatch = useDispatch();
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [step, setStep] = useState(0);
	const [agreementAll, setAgreementAll] = useState(false);

	const [userInfo, setUserInfo] = useState({
		phone: null,
		phone_valid: null,
		password: null,
		password_valid: null,
	});
	const [smsValid, setSmsValid] = useState(false);
	const [passwordValid, setPasswordValid] = useState(true);

	const [questionList, setQuestionList] = useState([]);
	const [selectKeys, setSelectKeys] = useState([]);
	const [selectEtc, setSelectEtc] = useState([]);
	const [genderAge, setGenderAge] = useState({
		gender: 1,
		age: moment(),
	});

	const queryJson = queryString.parse(
		history.location.search?.replace("?", "")
	);
	const channelId = queryJson?.id;

	useEffect(() => {
		// if (reduxChannel?.influencer_id) {
		//     if (channelId) {
		//         if (reduxChannel?.user_id !== 8 || reduxChannel?.user_id !== 1) {
		//             if (!(channelId === 'squidtv' || channelId === 'admin')) {
		//                 history.replace(`/together/channel?id=${channelId}`);
		//             }
		//         }
		//     }
		// }
		if (cUser?.id) {
			history.goBack();
		}
		getQuestionList();
	}, [reduxChannel, history]);

	/**
	 * 이전으로 가기
	 */
	const cancelSignup = () => {
		if (step === 0) {
			history.go(-1);
		} else if (step === 1) {
			setStep(0);
		}
	};

	/**
	 * step 0, step 1, step 2 ) 약관동의, 회원가입 정보, 방문경로 입력
	 */
	const handleSubmitSignUp = () => {
		if (step === 0) {
			if (agreementAll) {
				setStep(1);
			} else {
				toastAlert("필수 항목을 모두 동의해주세요.");
			}
		} else if (step === 1) {
			if (smsValid) {
				if (
					!!userInfo.password_valid?.length &&
					userInfo?.password === userInfo?.password_valid
				) {
					if (userInfo?.password?.length >= 8) {
						setPasswordValid(true);
						setStep(2);
					} else {
						toastAlert("8자리 이상 비밀번호를 입력해주세요.");
					}
				} else {
					setPasswordValid(false);
					toastAlert("비밀번호를 확인해주세요.");
				}
			} else {
				toastAlert("휴대폰 인증을 완료해주세요.");
			}
		} else if (step === 2) {
			if (questionList?.length) {
				setStep(3);
			} else {
				onSubmitSignUp();
			}
		} else if (step === 3) {
			let valid = false;
			for (let i = 0; i < selectKeys?.length; i++) {
				if (!selectKeys[i]?.length) {
					valid = true;
					break;
				}
			}
			if (!valid) {
				onSubmitSignUp();
			} else {
				toastAlert("가입 질문에 답해주세요.");
			}
		}
	};

	/**
	 * 회원가입 질문 목록 가져오기
	 * @returns {Promise<void>}
	 */
	const getQuestionList = async () => {
		const param = {
			influencerId: reduxChannel?.user_id,
			type: "signup",
		};
		const res = await channelUserApi.getSignUpQuestionList(param);
		if (res.code === 200) {
			setQuestionList(res.result?.questionList);
			let selectList = [];
			for (let i = 0; i < res.result?.questionCnt; i++) {
				selectList.push([]);
			}
			setSelectKeys(selectList);
			setSelectEtc(selectList);
		}
	};

	/**
	 * 가입하기
	 * @returns {Promise<void>}
	 */
	const onSubmitSignUp = async () => {
		let list = [];
		setIsLoading(false);
		for (let i = 0; i < questionList?.length; i++) {
			list.push(
				// eslint-disable-next-line no-unsafe-optional-chaining
				...selectKeys[i]?.map((item) => ({
					question_id: questionList[i]?.id,
					answer: `${item !== "기타" ? item : selectEtc[i]}`,
				}))
			);
		}
		const param = {
			influencer_id: reduxChannel?.user_id,
			users: {
				phone: userInfo?.phone,
				provider: null,
				provider_id: null,
				password: userInfo?.password,
				gender: genderAge.gender,
				birthday: genderAge.age,
				influencer_id: reduxChannel?.user_id,
			},
			answerList: list,
		};

		const res = await channelUserApi.signUp(param);
		if (res.code === 200) {
			const result = res.result;
			console.log(result);
			localStorage.setItem("accessToken", result.tokenDto.accessToken);
			localStorage.setItem("refreshToken", result.tokenDto.refreshToken);
			dispatch(setChannelUser(result.users));

			history.replace(
				`/together/channel/signup/success?id=${reduxChannel?.influencer_id}`
			);

			setIsLoading(false);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				setIsLoading(false);
			});
			// window.alert("일시적인 오류로 실패하였습니다. 다시 시도해주세요.");
		}
	};

	return (
		<div className={`channel-wrap channel-home channel-delay`}>
			<div className={`home-body home-each`}>
				<div className={`max-width-apply`}>
					<div className={`home-recommend-horizontal sign-up-div`}>
						<div className={`recommend-title`}>
							<p className={`title`}>회원가입</p>
						</div>
						<div className={`signup-body`}>
							{step === 0 ? (
								<SignupAgreement
									agreementAll={agreementAll}
									setAgreementAll={setAgreementAll}
								/>
							) : step === 1 ? (
								<SignupUserInfo
									userInfo={userInfo}
									setUserInfo={setUserInfo}
									smsValid={smsValid}
									setSmsValid={setSmsValid}
									passwordValid={passwordValid}
								/>
							) : step === 2 ? (
								<SignupGenderAge
									genderAge={genderAge}
									setGenderAge={setGenderAge}
								/>
							) : (
								<SignRouteSurvey
									questionList={questionList}
									selectKeys={selectKeys}
									setSelectKeys={setSelectKeys}
									selectEtc={selectEtc}
									setSelectEtc={setSelectEtc}
								/>
							)}
						</div>

						<div className={`signup-footer`}>
							{step === 0 || step === 1 ? (
								<ButtonGroup>
									<Button onClick={cancelSignup} loading={isLoading}>
										이전
									</Button>
									<Button
										className={`black-button`}
										onClick={handleSubmitSignUp}
										loading={isLoading}
									>
										다음
									</Button>
								</ButtonGroup>
							) : step === 2 ? (
								<>
									{questionList?.length ? (
										<ButtonGroup>
											<Button onClick={cancelSignup} loading={isLoading}>
												이전
											</Button>
											<Button
												className={`black-button`}
												onClick={handleSubmitSignUp}
												loading={isLoading}
											>
												다음
											</Button>
										</ButtonGroup>
									) : (
										<ButtonGroup>
											<Button
												className={`black-button`}
												style={{ width: "100%" }}
												onClick={handleSubmitSignUp}
												loading={isLoading}
											>
												가입하기
											</Button>
										</ButtonGroup>
									)}
								</>
							) : (
								<ButtonGroup>
									<Button
										className={`black-button`}
										style={{ width: "100%" }}
										onClick={handleSubmitSignUp}
										loading={isLoading}
									>
										가입하기
									</Button>
								</ButtonGroup>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default SignUp;
